// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"332":"component---src-templates-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"332":"b8a9c3817de67fef6599","883":"0e84e19da814f0e0e4b6"}[chunkId] + ".js";
};